import { ContentSection, Heading } from '@vwfs-bronson/bronson-react';
import { TotalEarlySettlement } from 'components/contracts/early-settlement/total-early-settlement/TotalEarlySettlement';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export const TotalEarlySettlementPage: React.FC = () => {
    const { t } = useTranslation('total-early-settlement');
    const { encryptedContractNumber } = useParams<{ encryptedContractNumber: string }>();
    const title = t('headline');
    return (
        <ContentSection pageWrapSize="medium">
            <Heading level={1}>{title}</Heading>
            <TotalEarlySettlement encryptedContractNumber={encryptedContractNumber} />
        </ContentSection>
    );
};
